import UserSetting from "./UserSetting";
import smsCampaign from "./smsCampaign";
import manageUser from "./manageUser";
import pushNotification from "./pushNotification";
import studio from "./studio";
import audience from "./audience";
import admin from "./admin";
import segment from "./segment";
import email from "./email";
import landingPage from "./landingPage";
import template from "./template";
import campaign from "./campaign";
import variable from "./variable";

export default {
  UserSetting: UserSetting,
  smsCampaign: smsCampaign,
  manageUser: manageUser,
  pushNotification: pushNotification,
  segment: segment,
  studio: studio,
  audience: audience,
  admin: admin,
  email: email,
  landingPage,
  template: template,
  campaign: campaign,
  variable: variable,
};

// export const RepositoryFactory = {
//   get: name => repositories[name],
//   post: name => repositories[name]
// };
